var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 46,
    viewBox: "0 0 70 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_4229_11464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M69.2858 0.142578H0.714355V45.8569H69.2858V0.142578Z",
    fill: "#166DD7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.714355 0.142578H69.2858L35.0001 22.9997L0.714355 0.142578Z",
    fill: "#ADCCF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M69.2858 45.8569V0.142578L0.714355 45.8569H69.2858Z",
    fill: "#0B3E91"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4229_11464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.5714,
    height: 45.7143,
    fill: "white",
    transform: "translate(0.714355 0.142578)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFrame);
export default __webpack_public_path__ + "static/media/icon-frame.d05bab37cea3b6fe3362f2b1c6c017c1.svg";
export { ForwardRef as ReactComponent };